export default "__VITE_ASSET__61Gpy80Q__"